(function () {
  'use strict';

  if (window.ProductGroupSwitcherInitialized) return;
  window.ProductGroupSwitcherInitialized = true;

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function initAll(root) {
    var context = root || document;
    var productInfos = context.querySelectorAll('product-info');

    productInfos.forEach(function (infoEl) {
      if (!infoEl || infoEl.__productGroupController) return;

      var script = infoEl.querySelector('script[type="application/json"][data-product-group-options]');
      if (!script) return;

      var data;
      try {
        data = JSON.parse(script.textContent || '[]');
      } catch (e) {
        console.error('[ProductGroup] Failed to parse group JSON', e);
        return;
      }

      if (!Array.isArray(data) || data.length <= 1) {
        return;
      }

      infoEl.__productGroupController = new ProductGroupController(infoEl, data);
    });
  }

  function ProductGroupController(infoEl, options) {
    this.infoEl = infoEl;
    this.options = options;

    var match = window.location.pathname.match(/\/products\/([^/?]+)/);
    this.currentHandle = match && match[1] ? match[1] : null;

    var current = this.options.find(function (o) {
      return o.handle === this.currentHandle;
    }.bind(this));

    this.currentMaterial = current && current.material ? current.material : null;
    this.currentSize = current && current.size ? current.size : null;

    this.materialRoot = infoEl.querySelector('[data-product-group-root][data-group-type="material"]');
    this.sizeRoot = infoEl.querySelector('[data-product-group-root][data-group-type="size"]');

    this.bindEvents();
    this.syncActiveStates();
  }

  ProductGroupController.prototype.bindEvents = function () {
    var self = this;

    if (this.materialRoot) {
      this.materialRoot.addEventListener('click', function (event) {
        var target = event.target.closest('[data-group-option]');
        if (!target) return;
        var li = target.closest('[data-group-value]');
        if (!li) return;
        var value = li.getAttribute('data-group-value');
        if (!value || value === self.currentMaterial) return;
        self.onOptionSelected('material', value, target);
      });
    }

    if (this.sizeRoot) {
      this.sizeRoot.addEventListener('click', function (event) {
        var target = event.target.closest('[data-group-option]');
        if (!target) return;
        var li = target.closest('[data-group-value]');
        if (!li) return;
        var value = li.getAttribute('data-group-value');
        if (!value || value === self.currentSize) return;
        self.onOptionSelected('size', value, target);
      });
    }
  };

  ProductGroupController.prototype.onOptionSelected = function (type, value, triggerEl) {
    if (type === 'material') {
      this.currentMaterial = value;
    } else if (type === 'size') {
      this.currentSize = value;
    }

    var target = this.findTargetProduct();
    if (!target || !target.handle || target.handle === this.currentHandle) {
      this.syncActiveStates();
      return;
    }

    this.switchToProduct(target.handle, triggerEl);
  };

  ProductGroupController.prototype.findTargetProduct = function () {
    var material = this.currentMaterial;
    var size = this.currentSize;
    var options = this.options;

    var candidates = options.filter(function (o) {
      var matchMaterial = !material || !o.material || o.material === material;
      var matchSize = !size || !o.size || o.size === size;
      return matchMaterial && matchSize;
    });

    if (candidates.length) return candidates[0];

    if (material) {
      candidates = options.filter(function (o) {
        return o.material && o.material === material;
      });
      if (candidates.length) return candidates[0];
    }

    if (size) {
      candidates = options.filter(function (o) {
        return o.size && o.size === size;
      });
      if (candidates.length) return candidates[0];
    }

    return options[0] || null;
  };

  ProductGroupController.prototype.switchToProduct = function (handle, triggerEl) {
    var infoEl = this.infoEl;
    var productUrl = '/products/' + handle;

    // Prefer using ProductInfo's own variant-change handler so we
    // respect its internal state and view transitions.
    if (!infoEl || typeof infoEl.handleOptionValueChange !== 'function') {
      window.location.href = productUrl;
      return;
    }

    // Use the clicked element as the "target" so focus behaviour is sane.
    var targetNode = triggerEl || infoEl;
    if (targetNode) {
      targetNode.dataset.productUrl = productUrl;
    }

    var fauxEvent = { target: targetNode };

    infoEl.handleOptionValueChange({
      data: {
        event: fauxEvent,
        target: targetNode,
        selectedOptionValues: []
      }
    });

    // Update internal current handle so future comparisons are correct.
    this.currentHandle = handle;
  };

  ProductGroupController.prototype.syncActiveStates = function () {
    var material = this.currentMaterial;
    var size = this.currentSize;

    if (this.materialRoot) {
      var items = this.materialRoot.querySelectorAll('[data-group-value]');
      items.forEach(function (item) {
        var value = item.getAttribute('data-group-value');
        if (material && value === material) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });

      var label = this.materialRoot.querySelector('[data-group-current-label]');
      if (label && material) {
        label.textContent = ' : ' + material;
      }
    }

    if (this.sizeRoot) {
      var sizeItems = this.sizeRoot.querySelectorAll('[data-group-value]');
      sizeItems.forEach(function (item) {
        var value = item.getAttribute('data-group-value');
        if (size && value === size) {
          item.classList.add('active');
        } else {
          item.classList.remove('active');
        }
      });

      var sizeLabel = this.sizeRoot.querySelector('[data-group-current-label]');
      if (sizeLabel && size) {
        sizeLabel.textContent = ' : ' + size;
      }
    }
  };

  onReady(function () {
    initAll(document);
  });

  document.addEventListener('product-info:loaded', function () {
    // After ProductInfo swaps content, re-scan the whole document
    // so new <product-info> instances receive controllers.
    initAll(document);
  });

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (event) {
      initAll(event.target);
    });
  }
})();
